export default __webpack_public_path__ + "images/58_2_image.jpg";